import React, { useState } from 'react';
import Button from 'atomic/button';
import { QuestionsAndAnswersItemInterface } from 'modules/product/views/components/product-questions-answers/interfaces/questions-and-answers-item.interface';
import ProductQuestion from 'modules/product/views/components/product-questions-answers/components/product-question';
import QuestionsAnswersStructuralData
    from 'modules/product/views/components/product-questions-answers/components/questions-answers-structural-data';

import './product-questions.scss';

interface ProductQuestionsProps {
    questions: QuestionsAndAnswersItemInterface[];
    offerLink?: string;
}

const ProductQuestions: React.FC<ProductQuestionsProps> = ({ questions, offerLink }) => {
    const [isShowQuestions, setIsShowQuestions] = useState(false);

    const onToggleQuestions = (): void => {
        setIsShowQuestions(isShowQuestions => !isShowQuestions);
    };

    return (
        <div className="questions">
            <ul className="questions__list">
                {questions.slice(0, isShowQuestions ? questions.length : 2).map(question => (
                    <li
                        className="questions__item"
                        key={question.id}
                    >
                        <ProductQuestion
                            offerLink={offerLink}
                            author={question.author}
                            createdAt={question.createdAt}
                            text={question.text}
                            answers={question.children}
                        />
                    </li>
                ))}
            </ul>
            {questions.length > 2 && (
                <Button
                    size="lg"
                    color="transparent-secondary"
                    onClick={onToggleQuestions}
                >
                    {isShowQuestions ? 'Zwiń pytania' : 'Zobacz wszystkie pytania'}
                </Button>
            )}
            <p className="questions__text">
                Treści powstały przy wsparciu narzędzia sztucznej inteligencji
            </p>
            <QuestionsAnswersStructuralData questions={questions} />
        </div>
    );
};

export default ProductQuestions;
